import { FlareXMLDeclaration } from '@common/flare/constants/flare-xml-declaration.constant';
import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { defaultToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { NodeIdAttrName, NodeIdRootValue } from '@common/prosemirror/model/node-id';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { OperationAttrName } from '@common/prosemirror/operations/operations.constant';
import { getSchemaAttrs } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

/** Project XML node names. */
export enum ProjectXmlNodeName {
  Project = 'CatapultProject',
  MetaTagList = 'MetaTagList',
}

/** Project tag XML node attribute names. */
export enum ProjectTagXmlAttributeName {
  MasterToc = 'MasterToc',
  BrandingStylesheet = 'BrandingStylesheet',
  MasterStylesheet = 'MasterStylesheet',
  MasterPageLayout = 'MasterPageLayout',
  Language = 'xml:lang',
}

export class ProjectSchemaPlugin extends SchemaPlugin {
  nodes: Dictionary<NodeSpec> = {
    doc: {
      content: ProjectXmlNodeName.Project,
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        let xml = FlareXMLDeclaration;

        for (let i = 0; i < node.childCount; i += 1) {
          const child = node.child(i);
          xml += (child.type.spec.toFlareXML ?? defaultToFlareXML)(child, options)
        }

        return xml;
      }
    },

    [ProjectXmlNodeName.Project]: {
      content: 'block*',
      attrs: {
        [NodeIdAttrName]: { default: NodeIdRootValue, skipExport: true },
        [OperationAttrName]: { default: undefined, skipExport: true },
        [ProjectTagXmlAttributeName.MasterToc]: { default: undefined },
        [ProjectTagXmlAttributeName.BrandingStylesheet]: { default: undefined },
        [ProjectTagXmlAttributeName.MasterStylesheet]: { default: undefined },
        [ProjectTagXmlAttributeName.MasterPageLayout]: { default: undefined },
        [ProjectTagXmlAttributeName.Language]: { default: undefined },
      },
      parseDOM: [{
        tag: ProjectXmlNodeName.Project,
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, [
            ProjectTagXmlAttributeName.MasterToc,
            ProjectTagXmlAttributeName.BrandingStylesheet,
            ProjectTagXmlAttributeName.MasterStylesheet,
            ProjectTagXmlAttributeName.MasterPageLayout,
            ProjectTagXmlAttributeName.Language,
          ]);
        }
      }],
    },

    [ProjectXmlNodeName.MetaTagList]: {
      group: 'block',
      content: 'block*',
      parseDOM: [{ tag: ProjectXmlNodeName.MetaTagList }],
    }
  };
}
